import React from "react";
import { useGauge } from "use-gauge";

const START_ANGLE = 45;
const END_ANGLE = 315;


export default function GaugeWidget(props) {
    const { data } = props;
    const gauge = useGauge({
        domain: [0, 100],
        startAngle: START_ANGLE,
        endAngle: END_ANGLE,
        numTicks: 21,
        diameter: 120
    });

    const needle = gauge.getNeedleProps({
        data,
        baseRadius: 12,
        tipRadius: 2
    });

    let value
    let valueInfo
    let max
    let valueToShow
    let percentage = 0
    let label
    let dataset
    if (data?.datasets && data?.datasets[0] && data?.datasets[0].data) {
        value = data?.datasets[0].data[0]
        valueToShow = value
        max = data?.datasets[0].maxValue
        dataset = data?.datasets[0]
    }
    valueInfo = data?.datasets[0]?.info
    if (data.labels) {
        label = data.labels[0]

    }

    if (!max && value) {
        percentage = 100
    }

    if (max && value) {
        percentage = value / max * 100

    }



    return (
        <div className="mt-3 mb-3 flexcc w-100">
            <svg className="w-100 overflow-visible p-2" style={{ overflow: 'visible' }} {...gauge.getSVGProps()}>
                <g id="arcs">
                    <path
                        {...gauge.getArcProps({
                            offset: 30,
                            startAngle: START_ANGLE,
                            endAngle: END_ANGLE
                        })}
                        fill="none"
                        className="stroke-gray-200"
                        strokeLinecap="round"
                        strokeWidth={24}
                    />
                    <path
                        {...gauge.getArcProps({
                            offset: 30,
                            startAngle: START_ANGLE,
                            endAngle: gauge.valueToAngle((percentage > 100 ? 100 : percentage))
                        })}
                        fill="none"
                        stroke={dataset?.backgroundColor ?? "#4ade80"}
                        // className="stroke-green-400"
                        strokeLinecap="round"
                        strokeWidth={24}
                    />
                </g>
                <g id="ticks">
                    {gauge.ticks.map((angle) => {
                        const asValue = gauge.angleToValue(angle);
                        let showText = false//asValue === 20 || asValue === 80 || asValue === 50;

                        return (
                            <React.Fragment key={`tick-group-${angle}`}>
                                <line
                                    className="stroke-gray-300"
                                    strokeWidth={2}
                                    {...gauge.getTickProps({ angle, length: showText ? 12 : 6 })}
                                />
                                {showText && (
                                    <text
                                        className="text-sm fill-gray-400 font-medium"
                                        {...gauge.getLabelProps({ angle, offset: 20 })}
                                    >
                                        {asValue}
                                    </text>
                                )}
                            </React.Fragment>
                        );
                    })}
                </g>
                {/* <g id="needle">
                    <circle className="fill-gray-300" {...needle.base} r={20} />
                    <circle className="fill-gray-700" {...needle.base} />
                    <circle className="fill-gray-700" {...needle.tip} />
                    <polyline className="fill-gray-700" points={needle.points} />
                    <circle className="fill-white" {...needle.base} r={4} />
                </g> */}
                <g className="flexcc w-100" >
                    {!data.hidePercentage &&
                        <text
                            className=" text-semibold font-medium" style={{ fontSize: percentage.toFixed(1).length > 5 ? 20 : 28 }}
                            {...gauge.getLabelProps({ angle: 0, offset: 70 })}
                        >
                            {percentage.toFixed(1) + '%'}
                        </text>
                    }
                    {data.hidePercentage &&data.type == 'day' &&
                        <text
                            className=" text-semibold font-medium" style={{ fontSize: percentage.toFixed(1).length > 5 ? 20 : 28 }}
                            {...gauge.getLabelProps({ angle: 0, offset: 70 })}
                        >
                            {(value ? value : '')}
                        </text>
                    }
                    <text
                        className="text-small text-semibold font-medium"
                        {...gauge.getLabelProps({ angle: 0, offset: 46 })}
                    >
                        {data.type != 'day' && (value ? value.toFixed(2) : value)} {valueInfo ? valueInfo : ''}

                    </text>

                    {/* <text
                        className="text-small text-semibold font-medium"
                        {...gauge.getLabelProps({ angle: 0, offset: 30 })}
                    >
                        {label}

                    </text> */}
                </g>
            </svg>
        </div>
    );
}
